import classNames from 'classnames';
import React from 'react';

import css from './SectionHowItWorks.module.css';
import { FormattedMessage } from 'react-intl';
import { H2, H3 } from '../../../components';

const steps = [
  {
    title: 'ArtistHelpPage.howItWorksStep1.title',
    subtitle: 'ArtistHelpPage.howItWorksStep1.subtitle',
    textList: [
      'ArtistHelpPage.howItWorksStep1.item1',
      'ArtistHelpPage.howItWorksStep1.item2',
      'ArtistHelpPage.howItWorksStep1.item3',
      'ArtistHelpPage.howItWorksStep1.item4',
    ],
  },
  {
    title: 'ArtistHelpPage.howItWorksStep2.title',
    subtitle: 'ArtistHelpPage.howItWorksStep2.subtitle',
    textList: [
      'ArtistHelpPage.howItWorksStep2.item1',
      'ArtistHelpPage.howItWorksStep2.item2',
      'ArtistHelpPage.howItWorksStep2.item3',
      'ArtistHelpPage.howItWorksStep2.item4',
      'ArtistHelpPage.howItWorksStep2.item5',
      'ArtistHelpPage.howItWorksStep2.item6',
      'ArtistHelpPage.howItWorksStep2.item7',
      'ArtistHelpPage.howItWorksStep2.item8',
    ],
  },
];

const SectionHowItWorks = props => {
  const { className } = props;

  return (
    <div className={classNames(className, css.root)}>
      <H2 className={css.title}>
        <FormattedMessage
          id="ArtistHelpPage.howItWorksTitle"
          values={{ span: msgFragment => <span className={css.primaryColor}>{msgFragment} </span> }}
        />
      </H2>
      <div className={css.sectionsWrapper}>
        {steps.map((step, index) => (
          <div className={css.section} key={step.title}>
            <H3 className={classNames(css.h3, css.primaryColor)}>
              {`${index + 1}.`}&nbsp;
              <FormattedMessage id={step.title} />
            </H3>
            <div className={css.subtitle}>
              <FormattedMessage id={step.subtitle} />
            </div>
            <ul className={css.list}>
              {step.textList.map(item => (
                <li className={css.item} key={item}>
                  <FormattedMessage id={item} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWorks;
